import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 8F09C6B0-DFE8-4700-A90A-476EFA6454F4
 * name stairs-up
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/stairs-up.svg
 * tags
 * - Transportation + Other 
 */
export const StairsUpIcon = createSvgIcon(<><path d="M15 6H22V9H18V13H14V17H10V21H3V18H7V14H11V10H15V6M10.17 6.66L4.66 12.17L2.83 10.34L8.34 4.83L6.5 3H12V8.5L10.17 6.66Z" /></>, 'StairsUpIcon');
export default StairsUpIcon